import { createContext, Dispatch, SetStateAction, useContext, useRef, useState } from 'react';

export interface IUnifiedFilter {
  // Order 관련
  orderNewStatusCdList?: Array<string | number>;
  orderOngoingCdList?: Array<string | number>;
  noOrderBzStepCd?: boolean; // => 참고용
  orderBzStepCdList?: Array<string | number>;
  orderPrcnt?: string | number;
  orderSign?: number;

  // Sales 관련
  salesNewStatusCdList?: Array<string | number>;
  salesOngoingCdList?: Array<string | number>;
  noSalesBzStepCd?: boolean; // => 참고용
  salesBzStepCdList?: Array<string | number>;
  salesPrcnt?: string | number;
  salesSign?: number;

  // Project 관련
  newStatusCdList?: Array<string | number>;
  ongoingCdList?: Array<string | number>;
  noBzStepCd?: boolean; // => 참고용
  bzStepCdList?: Array<string | number>;
  // orderPrcnt?: string; => 중복
  // orderSign?: string; => 중복
  text?: string;
}

type Callback = (filter?: IUnifiedFilter) => Promise<void>;

interface SearchFilterContextType {
  registerCallback: (fn: Callback) => void;
  executeCallback: (filter?: IUnifiedFilter) => Promise<void>;
  filter: IUnifiedFilter | undefined;
  setFilter: (filter: IUnifiedFilter | undefined) => void;
  openFilter: boolean;
  setOpenFilter: Dispatch<SetStateAction<boolean>>;
}

const SearchFilterContext = createContext<SearchFilterContextType | null>(null);

export const useSearchFilterContext = () => {
  const ctx = useContext(SearchFilterContext);
  if (!ctx) throw new Error('SearchFilterContext not found');
  return ctx;
};

export const SearchFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const callbackRef = useRef<Callback>();
  const [filter, setFilter] = useState<IUnifiedFilter | undefined>(undefined);

  const registerCallback = (fn: Callback) => {
    callbackRef.current = fn;
  };

  const executeCallback = async (f?: IUnifiedFilter) => {
    setFilter(f);
    if (callbackRef.current) await callbackRef.current(f);
  };

  const [openFilter, setOpenFilter] = useState(false);
  return (
    <SearchFilterContext.Provider
      value={{
        registerCallback,
        executeCallback,
        filter,
        setFilter,
        openFilter,
        setOpenFilter,
      }}
    >
      {children}
    </SearchFilterContext.Provider>
  );
};
